import { values as _values } from 'lodash';

const iconTypes = {
  image: 'image',
  animatedImage: 'animatedImage',
  svgImage: 'svgImage',
};

export const IconTypesValues = _values(iconTypes);

export default iconTypes;
